/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCustomerDemandMutationVariables = Types.Exact<{
  subject: Types.Scalars['String'];
  body: Types.Scalars['String'];
}>;


export type CreateCustomerDemandMutation = { createCustomerDemand: boolean };


export const CreateCustomerDemandDocument = gql`
    mutation CreateCustomerDemand($subject: String!, $body: String!) {
  createCustomerDemand(subject: $subject, body: $body)
}
    `;

/**
 * __useCreateCustomerDemandMutation__
 *
 * To run a mutation, you first call `useCreateCustomerDemandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerDemandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerDemandMutation, { data, loading, error }] = useCreateCustomerDemandMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateCustomerDemandMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerDemandMutation, CreateCustomerDemandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerDemandMutation, CreateCustomerDemandMutationVariables>(CreateCustomerDemandDocument, options);
      }
export type CreateCustomerDemandMutationHookResult = ReturnType<typeof useCreateCustomerDemandMutation>;
export type CreateCustomerDemandMutationResult = Apollo.MutationResult<CreateCustomerDemandMutation>;
export type CreateCustomerDemandMutationOptions = Apollo.BaseMutationOptions<CreateCustomerDemandMutation, CreateCustomerDemandMutationVariables>;